// common functions for dealing with cookies. this was cribbed from an old
// legacy file so cut me some slack1!!!!11!!!!!!!!!
// -----------------------------------------------------------------------

const getPageTopDomain = () => {
	const host = window.location.host;
	const parts = host.split(".");
	let res = `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;

	if (res.indexOf(":") !== -1) {
		res = res.substr(0, res.indexOf(":"));
	}

	return res;
};

const Cookies = {
	setCookie(name, value, expires) {
		const curCookie = `${name}=${escape(value)
		}${(expires) ? `; expires=${expires.toGMTString()}` : ""
		}; path=/` +
				`; domain=${getPageTopDomain()}`;
		document.cookie = curCookie;
	},

	deleteCookie(name) {
		if (Cookies.getCookie(name)) {
			document.cookie = `${name}=` +
			`; domain=${getPageTopDomain()
			}; path=/` +
			"; expires=Thu, 01-Jan-70 00:00:01 GMT";
		}
	},

	getCookie(name) {
		const dc = document.cookie;
		const prefix = `${name}=`;
		let begin = dc.indexOf(`; ${prefix}`);

		if (begin === -1) {
			begin = dc.indexOf(prefix);

			if (begin !== 0) return null;
		} else {
			begin += 2;
		}

		let end = document.cookie.indexOf(";", begin);

		if (end === -1) {
			end = dc.length;
		}

		return unescape(dc.substring(begin + prefix.length, end));
	},
};

export default Cookies;



// WEBPACK FOOTER //
// ./src/shared/util/Cookies.js